module.exports = __webpack_public_path__ + "static/media/32_B.187be64a.png";